import { Button } from '@energiebespaarders/symbols';
import styled from 'styled-components';
import type { ButtonProps } from '@energiebespaarders/symbols/components/Button';
import type { AnimatedProps } from '@energiebespaarders/symbols/lib/hoc/withAnimation';
import type { SpacingProps } from '@energiebespaarders/symbols/lib/hoc/withSpacing';
import type { FC } from 'react';
import type { DefaultTheme, StyledComponent } from 'styled-components';

// Define a styled button where parent props can override defaults
const ActionButton = styled(Button).attrs<ButtonProps & SpacingProps & Partial<AnimatedProps>>(
  props => ({
    px: props.px ?? 3, // Allow parent props to override, otherwise default to 3
    mr: props.mr ?? 0,
    mb: props.mb ?? 0,
    bgColor: props.bgColor ?? 'yellow',
    color: props.color ?? 'grayBlack',
  }),
)`
  white-space: nowrap;
  border-radius: 3px;
`;

const SecondaryActionButton = styled(Button).attrs<
  ButtonProps & SpacingProps & Partial<AnimatedProps>
>(props => ({
  px: props.px ?? 3, // Allow parent props to override, otherwise default to 3
  mr: props.mr ?? 0,
  mb: props.mb ?? 0,
  bgColor: props.bgColor ?? 'grayBlack',
  color: props.color ?? 'white',
  inverse: props.inverse ?? true,
}))`
  white-space: nowrap;
  border-radius: 3px;
`;

export default ActionButton as StyledComponent<
  FC<(ButtonProps & SpacingProps) & Partial<AnimatedProps>>,
  DefaultTheme,
  object,
  never
>;

export const ActionButtonSecondary = SecondaryActionButton as unknown as StyledComponent<
  FC<(ButtonProps & SpacingProps) & Partial<AnimatedProps>>,
  DefaultTheme,
  object,
  never
>;
